import { SignerDetailVariant } from '../../types/contract-order/signer-detail-variant.type';
import { StatusBoxConfig } from '../../models/contract-order/status-box-config.model';

export const signerStatusBoxConfigMapper = new Map<SignerDetailVariant, StatusBoxConfig>([
  [
    'success',
    {
      bg: 'bg-success-surface-tint',
      iconColor: 'text-success!',
      icon: 'check-circle-outline',
      textColor: 'text-success',
      labelKey: 'ORDER-DETAILS.SIGNED-ON',
    },
  ],
  [
    'danger',
    {
      bg: 'bg-danger-surface-tint',
      iconColor: 'text-danger!',
      icon: 'close-circle-outline',
      textColor: 'text-danger-ink',
      labelKey: 'ORDER-DETAILS.REJECTED-ON',
    },
  ],
  [
    'warning',
    {
      bg: 'bg-warning-surface-tint',
      iconColor: 'text-warning-ink!',
      icon: 'danger-triangle-outline',
      textColor: 'text-warning-ink',
      labelKey: 'ORDER-DETAILS.REMINDER-SENT',
    },
  ],
]);
